import { isEmpty, pickBy } from 'lodash'
import { parseRef, scrubUndefined } from "../../firebase"

import { defaultListener, generateId } from "../helper"

export default {
  state: {
    eventItems: {}
  },
  getters: {
    getEventItemsWithoutGroup: (state) => (eventId) => {
      return Object.values(pickBy(state.eventItems, item => {
        return (item.eventGroupId === null || item.eventGroupId === undefined)
          && item.eventId === eventId
      }))
    },
    getEventItemsByGroupId: (state) => (eventGroupId) => {
      return Object.values(pickBy(state.eventItems, item => {
        return item.eventGroupId === eventGroupId
      }))
    },
    getEventItem: (state) => (id) => state.eventItems[ id ] || {},
    allEventItems: (state) => returnMap => {
      return returnMap
        ? state.eventItems
        : Object.values(state.eventItems)
    }
  },
  actions: {
    removeGroupFromEventItems({ getters }, itemIds) {
      const sessionTenant = getters.getSessionTenant
      const db = this.$firebase.firestore()
      const batch = db.batch()

      const merge = true

      itemIds.forEach(id => {
        const ref = db.collection('tenants')
          .doc(sessionTenant)
          .collection('eventItems')
          .doc(id)
        batch.set(ref, { eventGroupId: null }, { merge })
      })

      try {
        batch.commit().then((stuff) => console.log('done', stuff))
      } catch (e) {
        console.log(e)
      }
    },
    async deleteEventItems({ getters }, itemIds) {
      const sessionTenant = getters.getSessionTenant
      const db = this.$firebase.firestore()
      const batch = db.batch()

      try {
        itemIds.forEach(id => {
          const ref = db.collection('tenants')
            .doc(sessionTenant)
            .collection('eventItems')
            .doc(id)
          batch.delete(ref)
        })

        await batch.commit()
      } catch (e) {
        console.log(e)
      }
    },
    updateEventItemsGroup({ getters }, { eventGroupId, itemIds }) {
      const sessionTenant = getters.getSessionTenant
      const db = this.$firebase.firestore()
      const batch = db.batch()

      const merge = true

      itemIds.forEach(id => {
        const ref = db.collection('tenants')
          .doc(sessionTenant)
          .collection('eventItems')
          .doc(id)
        batch.set(ref, { eventGroupId }, { merge })
      })

      try {
        batch.commit().then((stuff) => console.log('done', stuff))
      } catch (e) {
        console.log(e)
      }
    },
    ensureEventItems({ commit, getters }, eventId) {
      const sessionTenant = getters.getSessionTenant

      if (!isEmpty(eventId)) {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('eventItems')
          .where('eventId', '==', eventId)
          .get()
          .then(ref => {
            const items = parseRef(ref)

            if (items) items.forEach(item => commit('ADD_EVENT_ITEM', item))
          })
          .catch(e => console.log(e))
      }
    },
    initEventItems({ commit, getters }, eventId) {
      const sessionTenant = getters.getSessionTenant

      if (!isEmpty(eventId)) {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('eventItems')
          .where('eventId', '==', eventId)
          .onSnapshot(
            defaultListener.bind(this, commit, 'ADD_EVENT_ITEM', 'REMOVE_EVENT_ITEM'),
            e => console.log('items error',e)
          )
      }
    },
    createEventItem({ getters }, data) {
      const {
        label = '',
        type = '',
        eventId,
        eventGroupId,
        meta = {}
      } = data

      const payload = { type, label, eventId, eventGroupId, meta }

      const sessionTenant = getters.getSessionTenant
      const id = generateId(sessionTenant, 'eventItems')
      const merge = true

      scrubUndefined(payload)


      console.log('creating', data, payload)

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('eventItems')
        .doc(id)
        .set(payload, { merge })
        .catch(e => console.log(e))
    },
    updateEventItem({ getters }, data) {
      const { label, type, eventId, meta = {}, id, eventGroupId } = data

      const { label: metaLabel, description: metaDescription, groups } = meta

      const payload = { type, label, eventId, eventGroupId,
        meta: { label: metaLabel, description: metaDescription, groups }
      }
      const sessionTenant = getters.getSessionTenant
      const merge = true

      scrubUndefined(payload)

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('eventItems')
        .doc(id)
        .set(payload, { merge })
        .catch(e => console.log(e))
    }
  },
  mutations: {
    ADD_EVENT_ITEM(state, eventItem) {
      const { id } = eventItem

      if (id) {
        const newState = { ...state.eventItems }
        newState[ id ] = eventItem
        state.eventItems = newState
      }
    },
    REMOVE_EVENT_ITEM(state, id) {
      if (state.eventItems[ id ]) {
        const newState = { ...state.eventItems }
        delete newState[ id ]
        state.eventItems = newState
      }
    }
  },
}
